// Dependencies
import React from 'react';
import _ from 'lodash';
import { Helpers } from '../utils';
import { CSSTransition } from 'react-transition-group'
import { CSSTransitionProps } from 'react-transition-group/CSSTransition'

// Contexts
import AppProvider from '../contexts/AppContext';

// Components 
import Product from './ProductView'; 
import ProductAreaLoader from '../components/ProductAreaLoader';
 
// Types
import { Containers, Types } from '../types';  
import styled, { css, ThemeProvider } from 'styled-components';
import { useDebug } from '../hooks/useDebug';
 
const ProductArea = ({loading, addingToCart, errors, ...props}: any) => {

    const transitionProps: CSSTransitionProps = React.useMemo(() => ({
        timeout: Number(props.theme.general.transition.duration.replace('ms', '')),
        unmountOnExit: true
      }), [props.theme.general.transition.duration])
  
      return (
        // TODO: Handle add to cart from here (probably) 
        <ThemeProvider theme={props.theme}>
            <ProductAreaWrapper theme={props.theme}>
                <CSSTransition timeout={0} unmountOnExit in={(loading && ! addingToCart) || ! _.isEmpty(errors) }>
                    <LoadingOverlay position="relative">
                        <ProductAreaLoader {...{...props.theme.general.loader, type: props.product.type}} />
                    </LoadingOverlay>
                </CSSTransition>
                <CSSTransition {...transitionProps} in={addingToCart} classNames="overlay">
                    <LoadingOverlay position="absolute"/>
                </CSSTransition>
                <CSSTransition timeout={0} unmountOnExit in={! loading || addingToCart}>
                    <Product {...props}/>
                </CSSTransition>
            </ProductAreaWrapper>
        </ThemeProvider> 
    )

}
export const LoadingOverlay = styled.div<any>(
    ({ position, theme: { general, components: { productAttributes: style } } }) => css`
        position: ${position ?? 'relative'};
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
        flex: 1;
        z-index: 10;
        background: rgba(255, 255, 255, .5);
        &.overlay-enter {
        opacity: 0;
      }
    
      &.overlay-enter-active {
        opacity: 1;
        transition: opacity ${general.transition.duration} ${general.transition.timingFunction};
      }
    
      &.overlay-exit-active {
        opacity: 0;
        transition: opacity ${general.transition.duration} ${general.transition.timingFunction};
      }
    `);
      
    
    const ProductAreaWrapper = styled.div`
        *, *::before, *::after {
            box-sizing: border-box;
        } 
        position: relative;
        width: 100%;
        height: fit-content;
        background: ${({theme: {general}}) => general.wrapper.background};
        font-size: ${({theme: {general}}) => general.sizingBase}px;
    `;
    
    export default ProductArea; 
    
    
